import React from "react";

export default (props) => {
	return (
		<div className="view">
			{props.children}
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/js/common/components/layouts/View.js